module.exports = import("https://cdn.jsdelivr.net/npm/php-wasm/PhpWeb.mjs");;